// src/components/Website/UserGuide/guideData.js
import { FaUserPlus, FaAddressBook, FaBullhorn, FaRobot, FaComments, FaRegFileAlt } from 'react-icons/fa';

const guideData = [
  {
    title: "איך ליצור חשבון?",
    description:
      "במדריך זה תלמד כיצד לפתוח חשבון חדש במערכת, להזין את פרטי העסק, לבחור תוכנית מתאימה ולהתחיל להשתמש בפלטפורמה שלנו בקלות ובמהירות.",
    path: "/guide/create-account",
    icon: FaUserPlus,
  },
  {
    title: "ניהול אנשי קשר",
    description:
      "כאן נלמד כיצד להוסיף אנשי קשר חדשים, לערוך פרטים קיימים, לסווג לקוחות לפי תגיות, ולשמור על סדר וניהול נכון של רשימת הלקוחות שלך.",
    path: "/guide/manage-contacts",
    icon: FaAddressBook,
  },
  {
    title: "יצירת קמפיין",
    description:
      "במדריך הזה תוכל ללמוד איך לבנות קמפיין הודעות יעיל – משלב בחירת הקהל, דרך ניסוח ההודעות, ועד שליחתן ובדיקת הביצועים.",
    path: "/guide/create-campaign",
    icon: FaBullhorn,
  },
  {
    title: "שימוש ב-Gambot AI",
    description:
      "גלה איך להפעיל את הבינה המלאכותית שלנו, לאמן אותה על בסיס שאלות ותשובות, ולקבל תגובות חכמות לשיחות נכנסות עם לקוחות.",
    path: "/guide/use-gambot-ai",
    icon: FaRobot,
  },
  {
    title: "עבודה עם הצ׳אט",
    description:
      "למד איך להשתמש בצ'אט החכם לניהול שיחות עם לקוחות, כולל מענה מהיר, תגובות מוכנות מראש, ופתיחת שיחות אוטומטיות.",
    path: "/guide/use-chat",
    icon: FaComments,
  },
  {
    title: "הכנת Template",
    description:
      "כאן תמצא הסבר מפורט על איך ליצור תבניות הודעה מקצועיות לאישורים, תזכורות, שיווק ועוד – כולל עיצוב והתאמה אישית.",
    path: "/guide/create-template",
    icon: FaRegFileAlt,
  },
  {
    title: "עוד דוגמא Template",
    description:
      "כאן תמצא הסבר מפורט על איך ליצור תבניות הודעה מקצועיות לאישורים, תזכורות, שיווק ועוד – כולל עיצוב והתאמה אישית.",
    path: "/guide/create-template",
    icon: FaRegFileAlt,
  },
];

export default guideData;
